import React, {Component} from 'react';

class Footer extends Component {

    render() {
        return (
            <div>
                {/*<div>
                    <strong>{_this.props.msg('footer.copyright')}</strong> {_this.props.msg('footer.parentOrgName')}
                </div>*/}
            </div>
        );
    }

}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/common/Footer.js